"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Toggler = require("b2b-components/theme/components/Dropdown/Toggler");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _DropdownList = require("./DropdownList");
require("./Dropdown.scss");
const Dropdown = _ref => {
  let {
    children,
    className,
    isMenuVisible,
    links,
    content,
    onClick,
    onMouseEnter,
    onMouseLeave,
    dropdownTogglerRef,
    dropdownMenuRef,
    menuPositionConfig,
    hasPositionCalculated,
    togglerProps,
    dataAttributes
  } = _ref;
  const {
    left,
    arrowLeft,
    width
  } = menuPositionConfig;
  const rootClassName = (0, _classnames.default)('cds-Dropdown', className);
  const togglerClassName = (0, _classnames.default)('cds-Dropdown-Toggler', {
    [`${togglerProps?.className}`]: togglerProps?.className
  });
  const getStyleAttribute = (attributeName, value) => {
    if (value !== null) {
      return {
        [attributeName]: `${value}px`
      };
    }
    return {};
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: dropdownTogglerRef
  }, children || /*#__PURE__*/_react.default.createElement(_Toggler.Toggler, (0, _extends2.default)({}, togglerProps, {
    label: togglerProps?.label || '',
    className: togglerClassName
  })), isMenuVisible && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "cds-Dropdown-Menu"
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    style: {
      ...(!hasPositionCalculated && {
        opacity: 0
      }),
      ...getStyleAttribute('left', left),
      ...getStyleAttribute('width', width)
    },
    ref: dropdownMenuRef
  }), links && Array.isArray(links) ? /*#__PURE__*/_react.default.createElement(_DropdownList.DropdownList, {
    links: links
  }) : content || null, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Dropdown-MenuArrow",
    style: {
      ...getStyleAttribute('left', arrowLeft)
    }
  })));
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map